import React from 'react';
import {
  Box,
  IconButton,
  Typography,
  Tooltip
} from '@mui/material';
import { ArrowBack, Clear } from '@mui/icons-material';
import { PopoverListButtons } from '../../../Utils/styledComps';
const CustomAlignmentPopoverContent = ({
  selectedFeature,
  alignment,
  handleBackButtonClick,
  handlePopoverClose
}) => {
  const renderPopoverContent = () => {
    if (selectedFeature) {
      const feature = alignment.find(item => item.label === selectedFeature);
      return (
        <Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 1.25,
            py: 1
          }}>
            <Tooltip title="Back" arrow>
              <IconButton
                edge="start"
                onClick={handleBackButtonClick}
                aria-label="Go back"
                sx={{ borderRadius: 1 }}
              >
                <ArrowBack />
              </IconButton>
            </Tooltip>
            <Typography variant="h6" sx={{ color: 'action.hover', fontWeight: 800 }}>
              {selectedFeature}
            </Typography>
            <Tooltip title="Close menu" arrow>
              <IconButton
                edge="end"
                onClick={handlePopoverClose}
                aria-label="Close alignment menu"
                sx={{ borderRadius: 1 }}
              >
                <Clear />
              </IconButton>
            </Tooltip>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, m: 1.25, flexWrap: 'wrap' }}>
            {feature?.children?.map((obj, index) => (
              <Tooltip key={index} title={obj.label} arrow placement="bottom">
                <PopoverListButtons
                  onClick={obj.onClick}
                  aria-label={obj.label}
                  sx={{
                    width: 90,
                    height: 90,
                    padding: '6px 8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    transition: (theme) => theme.transitions.create(['transform'], {
                      duration: theme.transitions.duration.shorter,
                    }),
                    '&:hover': {
                      transform: 'translateY(-2px)',
                    },
                  }}
                >
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%'
                  }}>
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 0.5,
                      height: 40,
                      mb: 0.5
                    }}>
                      <Box component="span" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {obj.icon}
                      </Box>
                      {obj.children && (
                        <Box component="span" sx={{ fontSize: 15, opacity: 0.85 }}>▾</Box>
                      )}
                    </Box>
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: 11,
                        color: 'text.primary',
                        textAlign: 'center',
                        whiteSpace: 'normal',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        width: '100%'
                      }}
                    >
                      {obj.label}
                    </Typography>
                  </Box>
                </PopoverListButtons>
              </Tooltip>
            ))}
          </Box>
        </Box>
      );
    }

    return (
      <Box>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 1.25,
          py: 1
        }}>
          <Typography variant="h6" sx={{ color: 'action.hover', fontWeight: 800 }}>
            Alignment
          </Typography>
          <Tooltip title="Close menu" arrow>
            <IconButton
              edge="end"
              onClick={handlePopoverClose}
              aria-label="Close alignment menu"
              sx={{ borderRadius: 1 }}
            >
              <Clear />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, m: 1.25, flexWrap: 'wrap' }}>
          {alignment.map((obj, index) => (
            <Tooltip key={index} title={obj.label} arrow placement="bottom">
              <PopoverListButtons
                onClick={obj.onClick}
                aria-label={obj.label}
                sx={{
                  width: 90,
                  height: 90,
                  padding: '6px 8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  transition: (theme) => theme.transitions.create(['transform'], {
                    duration: theme.transitions.duration.shorter,
                  }),
                  '&:hover': {
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  height: '100%'
                }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 0.5,
                    height: 40,
                    mb: 0.5
                  }}>
                    <Box component="span" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {obj.icon}
                    </Box>
                    {obj.children && (
                      <Box component="span" sx={{ fontSize: 15, opacity: 0.85 }}>▾</Box>
                    )}
                  </Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: 11,
                      color: 'text.primary',
                      textAlign: 'center',
                      whiteSpace: 'normal',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      width: '100%'
                    }}
                  >
                    {obj.label}
                  </Typography>
                </Box>
              </PopoverListButtons>
            </Tooltip>
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <>
      {renderPopoverContent()}
    </>
  );
};

export default CustomAlignmentPopoverContent;
